import type { EditorView } from "@tiptap/pm/view";

export function posIsInViewport(pos: number, view: EditorView) {
  const coords = view.coordsAtPos(pos);

  const isInViewport =
    coords.top < window.innerHeight &&
    coords.bottom > 0 &&
    coords.left < window.innerWidth &&
    coords.right > 0;

  return isInViewport;
}
